import { render, staticRenderFns } from "./message.vue?vue&type=template&id=6e1044e9&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&lang=less&module=true&"
import style1 from "./message.vue?vue&type=style&index=1&id=6e1044e9&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6e1044e9",
  null
  
)

component.options.__file = "message.vue"
export default component.exports